import { Link, ArrowRightMd, spacingHelper } from '@construct-kit/core';
import React from 'react';
import styled from 'styled-components';

const StyledArrowRightMd = styled(ArrowRightMd)`
  transition: transform 0.2s ease-in-out;
`;

const MenuLink = styled(Link)`
  width: 100%;
  flex-grow: 1;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: ${spacingHelper('small')} ${spacingHelper('medium')};
  border-radius: 0;

  > span {
    flex-grow: 1;
  }

  &:hover ${StyledArrowRightMd} {
    transform: translateX(0.25rem);
  }
`;

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-left: ${spacingHelper('extraSmall')};
`;

type Props = {
  href: string;
  icon: React.ReactNode;
  children: React.ReactNode;
  onClick: () => void;
};

export const MenuItem: React.FC<Props> = ({
  href,
  icon,
  children,
  onClick,
}) => {
  return (
    <li>
      <MenuLink
        variant="button-naked"
        onClick={onClick}
        href={href}
        icon={icon}
      >
        <Wrapper>
          {children}
          <StyledArrowRightMd />
        </Wrapper>
      </MenuLink>
    </li>
  );
};
